module.exports = "<textarea (input)=\"change($event)\" [(ngModel)]=\"text\" name=\"text\" id=\"\"></textarea>\r\n"